import { dayjs } from "@outschool/time";
import { IS_REVIEW_APP, OUTSCHOOL_ENV } from "./Env";

export const BLACK_FRIDAY_SALE_COUPON_CODE = "BFCM";
const BLACK_FRIDAY_SALE_SAVINGS_AMOUNT_CENTS = 4000; // This is 2 months of $40 off, but just show for 1 month

// Sale runs from Tuesday 11/25 through end of Cyber Monday (12/1)
// Use earlier dates for development/staging/review apps to facilitate testing
// TODO: This ternary will be removed once its tested and ready for production
const BLACK_FRIDAY_SALE_START_DATE =
  OUTSCHOOL_ENV === "development" ||
  OUTSCHOOL_ENV === "staging" ||
  IS_REVIEW_APP
    ? "2025-11-18"
    : "2025-11-25";

// End date is exclusive in isBefore(), so set to 12/2 to include all of 12/1
const BLACK_FRIDAY_SALE_END_DATE = "2025-12-02";

export function IsValidTimeRangeForBlackFridaySale() {
  const EST_TIMEZONE = "America/New_York";
  const now = dayjs().tz(EST_TIMEZONE);
  const startDate = dayjs.tz(BLACK_FRIDAY_SALE_START_DATE, EST_TIMEZONE);
  const endDate = dayjs.tz(BLACK_FRIDAY_SALE_END_DATE, EST_TIMEZONE);

  return now.isSameOrAfter(startDate, "day") && now.isBefore(endDate, "day");
}

export const BTS40_COUPON_CODE = "BTS40";
const BTS_40_SAVINGS_AMOUNT_CENTS = 4000;

export const SCHOOL40_COUPON_CODE = "SCHOOL40";
// 40% off, so fractional discount is 0.4
const SCHOOL_40_FRACTIONAL_SAVINGS = 0.4;

export function getCouponCodeForPlan({
  plan,
}: {
  plan: {
    amountCents: number;
    numCredits: number;
  };
}) {
  // Black Friday coupon ($40 off 2 months) takes precedence
  if (
    IsValidTimeRangeForBlackFridaySale() &&
    (plan.numCredits === 80 || plan.numCredits === 145)
  ) {
    return BLACK_FRIDAY_SALE_COUPON_CODE;
  }
  // NOTE: Product decision to not use cookie coupon for auto-application
  // https://outschool.slack.com/archives/C07KF2AFN00/p1763662725987929?thread_ts=1763587340.958329&cid=C07KF2AFN00
  // Use cookie coupon if it exists and is NOT an invalid Black Friday coupon
  // if (couponFromCookie && couponFromCookie !== BLACK_FRIDAY_SALE_COUPON_CODE) {
  //   return couponFromCookie;
  // }

  const savingsBTS = getSavingsAmountCentsForCouponCode(
    BTS40_COUPON_CODE,
    plan.amountCents,
  );
  const savingsSchool = getSavingsAmountCentsForCouponCode(
    SCHOOL40_COUPON_CODE,
    plan.amountCents,
  );

  // Default to the base coupons that save the most money
  return savingsSchool > savingsBTS ? SCHOOL40_COUPON_CODE : BTS40_COUPON_CODE;
}

export function getSavingsAmountCentsForCouponCode(
  couponCode: string,
  priceAmountCents: number,
) {
  if (couponCode === BTS40_COUPON_CODE) {
    return BTS_40_SAVINGS_AMOUNT_CENTS;
  } else if (couponCode === SCHOOL40_COUPON_CODE) {
    return priceAmountCents * SCHOOL_40_FRACTIONAL_SAVINGS;
  } else if (couponCode === BLACK_FRIDAY_SALE_COUPON_CODE) {
    return BLACK_FRIDAY_SALE_SAVINGS_AMOUNT_CENTS;
  }

  throw new Error(
    `Called getSavingsAmountCentsForCouponCode with invalid coupon code: ${couponCode}`,
  );
}
